import { Link as FluentLink, makeStyles, tokens } from '@fluentui/react-components';
import FileIcon from '@modules/items/components/FileIcon';
import type { TSparseItem } from '@modules/items';
import { Link as RouterLink } from 'react-router-dom';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalM,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    minWidth: 0,
    textDecorationLine: 'none',
  },
});

type TProps = {
  documents?: TSparseItem[];
};

export const TaskDocumentLinks = ({ documents }: TProps) => {
  const classes = useStyles();

  if (!documents?.length) return null;

  return (
    <div className={classes.root}>
      {documents.map((document) => (
        <RouterLink
          key={document._id}
          to={`/documents/${encodeURIComponent(document._id)}`}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
          onClick={(event) => event.stopPropagation()}
          onKeyDown={(event) => event.stopPropagation()}
        >
          <FileIcon type="DOCUMENT" path={[]} isBlock={false} isFrozen={false} isTemplate={false} size="small" />
          <FluentLink as="span">{document.name}</FluentLink>
        </RouterLink>
      ))}
    </div>
  );
};
